import api from './api';

export interface Adresse {
  adresseID: number;
  anrede: string;
  titel?: string;
  vorname: string;
  nachname: string;
  firma?: string;
  email?: string;
  telefon?: string;
  strasse?: string;
  plz?: string;
  ort?: string;
  land?: string;
  rolle?: string; // For project assignments
}

export const adresseService = {
  // Get all addresses
  async getAll(): Promise<Adresse[]> {
    try {
      const response = await api.get<Adresse[]>('/adressen');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der Adressen:', error);
      return [];
    }
  },

  // Get addresses assigned to a project
  async getByProject(projectId: number): Promise<Adresse[]> {
    try {
      const response = await api.get<Adresse[]>(`/projects/${projectId}/addresses`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der zugeordneten Adressen:', error);
      return [];
    }
  },
};
